import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_WEEK_DAYS, WEEK_DAY_ERROR, UPDATE_WEEK_DAYS
} from './types';

import { base_url } from './constants';

axios.defaults.baseURL = base_url;

//GET Business Hours with day week
export const getDayWeeks = () => async dispatch => {
    try {
        const res = await axios.get('/api/day_weeks/');

        dispatch({ type: GET_WEEK_DAYS, payload: res.data });

    } catch (err) {
        dispatch({
            type: WEEK_DAY_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });
    }
}

// EDIT BUSINESS DAYS
export const updateBusinessDays = openStatus => async dispatch => {
    console.log(openStatus);
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    try {
        const res = await axios.put('/api/businessDays/update', openStatus, config);
        dispatch({
            type: UPDATE_WEEK_DAYS,
        });

        dispatch(setAlert('Updated', 'success'));

    } catch (err) {
        const errors = err.response.data.errors;

        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: WEEK_DAY_ERROR,
        });
    }
}


export const updateBusinessOpenHours = openTime => async dispatch => {
    console.log(openTime);
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    try {
        const res = await axios.put('/api/businessHours/update1', openTime, config);
        dispatch({
            type: UPDATE_WEEK_DAYS,
            payload: res.data
        });

        dispatch(setAlert('Updated', 'success'));
        getDayWeeks();

    } catch (err) {
        const errors = err.response.data.errors;

        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: WEEK_DAY_ERROR,
        });
    }
}


export const updateBusinessCloseHours = closeTime => async dispatch => {
    // console.log(closeTime);
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    try {
        const res = await axios.put('/api/businessHours/update2', closeTime, config);
        // dispatch({
        //     type: UPDATE_WEEK_DAYS,
        //     payload: res.data
        // });

        // dispatch(setAlert('Updated', 'success'));

        getDayWeeks();
    } catch (err) {
        const errors = err.response.data.errors;

        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: WEEK_DAY_ERROR,
        });
    }
}

